import { Component, Input } from '@angular/core';
@Component({
    selector: 'icon-fb',
    template: `
            <svg fill="currentColor" stroke="currentColor" [class]="class" viewBox="0 0 1024 1024" version="1.1"
                 xmlns="http://www.w3.org/2000/svg">
                <path d="M767.428571 6.857143l0 150.857143-89.714286 0q-49.142857 0-66.285714 20.571429t-17.142857 61.714286l0 108 167.428571 0-22.285714 169.142857-145.142857 0 0 433.714286-174.857143 0 0-433.714286-145.714286 0 0-169.142857 145.714286 0 0-124.571429q0-106.285714 59.428571-164.857143t158.285714-58.571429q84 0 130.285714 6.857143z"/>
            </svg>
    `,
    standalone: true
})
export class IconFb {
    @Input() class: any = '';
}
